import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'shc-welcome',
  templateUrl: './welcome.page.html',
  styleUrls: ['./welcome.page.scss'],
})
export class WelcomePage implements OnInit {

  constructor() { }

  ngOnInit() { }

}
